import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative bg-[#0A0F1E] text-white">
      {/* Gold accent line */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C9A96E]/30 to-transparent"></div>

      <div className="max-w-[1400px] mx-auto px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          {/* Logo & Description */}
          <div className="md:col-span-5 space-y-6">
            <img 
              src="https://static.readdy.ai/image/f30444846e2254d95b405efc135ce378/deea87c36f9c2a3377548eebefcbfbbb.png" 
              alt="Diivy Medical Technology" 
              className="h-11 w-auto object-contain brightness-0 invert"
            />
            <p className="text-[14px] leading-[1.8] text-white/50 font-light max-w-[380px]">
              A holding company developing technology platforms for patient safety, veterinary innovation, and RFID-enabled operational systems.
            </p>
          </div>

          {/* Navigation Columns */}
          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-12">
            {/* Company */}
            <div className="space-y-5">
              <h4 className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#C9A96E]">
                Company
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/about" className="text-[14px] text-white/60 hover:text-white transition-colors duration-300 whitespace-nowrap">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/portfolio" className="text-[14px] text-white/60 hover:text-white transition-colors duration-300 whitespace-nowrap">
                    Portfolio
                  </Link>
                </li>
                <li>
                  <Link to="/sectors" className="text-[14px] text-white/60 hover:text-white transition-colors duration-300 whitespace-nowrap">
                    Sectors
                  </Link>
                </li>
              </ul>
            </div>

            {/* Portfolio */}
            <div className="space-y-5">
              <h4 className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#C9A96E]">
                Portfolio
              </h4>
              <ul className="space-y-3">
                <li>
                  <a href="https://diitect.com" target="_blank" rel="noopener noreferrer" className="text-[14px] text-white/60 hover:text-white transition-colors duration-300 whitespace-nowrap">
                    Diitect
                  </a>
                </li>
                <li>
                  <span className="text-[14px] text-white/60 whitespace-nowrap">
                    Vetuvia
                  </span>
                </li>
                <li>
                  <span className="text-[14px] text-white/60 whitespace-nowrap">
                    RFID Solutions
                  </span>
                </li>
              </ul>
            </div>

            {/* Connect */}
            <div className="space-y-5">
              <h4 className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#C9A96E]">
                Connect
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/contact" className="text-[14px] text-white/60 hover:text-white transition-colors duration-300 whitespace-nowrap">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-[14px] text-white/60 hover:text-white transition-colors duration-300 whitespace-nowrap">
                    Investor Inquiry
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-[13px] text-white/40 font-light">
            © {new Date().getFullYear()} Diivy Medical Technology. All rights reserved.
          </p>
          <div className="flex items-center gap-8">
            <a href="#" className="text-[13px] text-white/40 hover:text-white transition-colors duration-300 whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" className="text-[13px] text-white/40 hover:text-white transition-colors duration-300 whitespace-nowrap">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}